export default __webpack_public_path__ + "static/media/kitap7.3bf06ae6.jpg";